module.exports = __webpack_public_path__ + "static/media/profile-tick.e7c739f0.svg";